import { render } from "./PresencesView.vue?vue&type=template&id=613a8a94"
import script from "./PresencesView.vue?vue&type=script&lang=js"
export * from "./PresencesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__